import { Wendy } from "./Wendy";
export default Wendy;
